export const COLORS = [
  "#e91e63",
  "#9c27b0",
  "#3f51b5",
  "#03a9f4",
  "#009688",
  "#8bc34a",
  "#ffeb3b",
  "#ff9800",
  "#795548",
  "#607d8b",
];
